import React, { Component } from 'react';

export default class Display_Cell_Label extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}
	}

	render() {
		let targetInfo = this.props.target_info;
		let header_font_size = (0.133) * this.props.cell_width + 2;

		let labelName = this.props.receiver.getString(targetInfo.id);

		switch (this.props.target_info.type) {
			case 'energyCatMonthLabel':
			case 'energyCatMonthValue':
			case 'energyCatMonthUnit':
				if (this.props.report_settings.hasOwnProperty('categories')) {
					if (this.props.report_settings.categories.hasOwnProperty('energy')) {
						if (this.props.report_settings.categories.energy.hasOwnProperty(targetInfo.id)) {
							labelName = this.props.report_settings.categories.energy[targetInfo.id].name + ' ' + this.props.receiver.getString('by_month');
						}
					}
				}
				break;
			case 'energyCatDayLabel':
			case 'energyCatDayValue':
			case 'energyCatDayUnit':
				if (this.props.report_settings.hasOwnProperty('categories')) {
					if (this.props.report_settings.categories.hasOwnProperty('energy')) {
						if (this.props.report_settings.categories.energy.hasOwnProperty(targetInfo.id)) {
							labelName = this.props.report_settings.categories.energy[targetInfo.id].name + ' ' + this.props.receiver.getString('by_day');
						}
					}
				}
				break;
			default:

		}

		return (
			<div>
				<span style={{ fontSize: header_font_size, display: 'inline-block', whiteSpace: 'nowrap' }}>{labelName}</span>
			</div>
		)
	}
}